import React from 'react';

var Checkmark = (function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '24' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: color,
    fillRule: "evenodd",
    points: "4.41 11.48 8.877 15.944 19.59 5.23 21 6.65 8.879 18.772 3 12.89"
  }));
});

export { Checkmark as default };
//# sourceMappingURL=checkmark.js.map
